module.exports = __webpack_public_path__ + "img/avatar-15.95b70da2.png";